export default __webpack_public_path__ + "static/media/banner.24538395.webp";